export default __webpack_public_path__ + "static/media/snack.2413c958.png";